import { render } from "./DashboardNavbar.vue?vue&type=template&id=148eb21e&scoped=true"
import script from "./DashboardNavbar.vue?vue&type=script&lang=js"
export * from "./DashboardNavbar.vue?vue&type=script&lang=js"

import "./DashboardNavbar.vue?vue&type=style&index=0&id=148eb21e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148eb21e"]])

export default __exports__